// src/constants/enums/assetStatus.js

/**
 * Asset Master Status Governance
 * Enterprise Asset Lifecycle Enum
 * 
 * PURPOSE:
 * - Centralize asset lifecycle states
 * - Prevent raw string corruption
 * - Standardize:
 *   Asset Master
 *   Transfers
 *   Returns
 *   Custody Engine
 *   Replay Engine
 *   Audit Engine
 */

export const ASSET_STATUS = {

    ACTIVE: 'ACTIVE',

INACTIVE: 'INACTIVE',

    /**
     * Asset available in inventory
     * Ready for assignment/transfer
     */
    AVAILABLE: 'AVAILABLE',

    /**
     * Asset currently assigned
     * Under active holder custody
     */
    IN_USE: 'IN_USE',

    /**
     * Asset moving between holders
     */
    IN_TRANSIT: 'IN_TRANSIT',

    /**
     * Return request initiated
     */
    RETURN_REQUESTED: 'RETURN_REQUESTED',

    /**
     * Asset returned successfully
     */
    RETURN_RECEIVED: 'RETURN_RECEIVED',

    /**
     * Asset marked defective
     * Requires repair/replacement/scrap decision
     */
    DEFECTIVE: 'DEFECTIVE',

    /**
     * Asset under repair workflow
     */
    UNDER_REPAIR: 'UNDER_REPAIR',

    /**
     * Asset repaired and reusable
     */
    REPAIRED: 'REPAIRED',

    /**
     * Asset permanently lost
     */
    LOST: 'LOST',

RECOVERED: 'RECOVERED',

SCRAPPED: 'SCRAPPED',

    /**
     * Asset archived/inactive
     */
    ARCHIVED: 'ARCHIVED',

};


/**
 * Final immutable statuses
 * No operational movement allowed
 */
export const FINAL_ASSET_STATUSES = [

    ASSET_STATUS.SCRAPPED,
    ASSET_STATUS.ARCHIVED,

];


/**
 * Validation helper
 */
export const isValidAssetStatus = (status) => {

    return Object.values(ASSET_STATUS).includes(status);

};


/**
 * UI-safe display labels
 */
export const ASSET_STATUS_LABELS = {

    [ASSET_STATUS.AVAILABLE]: 'Available',
    [ASSET_STATUS.RECOVERED]: 'Recovered',
    [ASSET_STATUS.IN_USE]: 'In Use',
    [ASSET_STATUS.IN_TRANSIT]: 'In Transit',
    [ASSET_STATUS.RETURN_REQUESTED]: 'Return Requested',
    [ASSET_STATUS.RETURN_RECEIVED]: 'Return Received',
    [ASSET_STATUS.DEFECTIVE]: 'Defective',
    [ASSET_STATUS.UNDER_REPAIR]: 'Under Repair',
    [ASSET_STATUS.REPAIRED]: 'Repaired',
    [ASSET_STATUS.LOST]: 'Lost',
    [ASSET_STATUS.SCRAPPED]: 'Scrapped',
    [ASSET_STATUS.ARCHIVED]: 'Archived',

};


/**
 * UI-safe color governance
 * Future badge/chip compatibility
 */
export const ASSET_STATUS_COLORS = {

    [ASSET_STATUS.AVAILABLE]: 'success',
    [ASSET_STATUS.RECOVERED]: 'success',
    [ASSET_STATUS.IN_USE]: 'primary',
    [ASSET_STATUS.IN_TRANSIT]: 'warning',
    [ASSET_STATUS.RETURN_REQUESTED]: 'warning',
    [ASSET_STATUS.RETURN_RECEIVED]: 'info',
    [ASSET_STATUS.DEFECTIVE]: 'error',
    [ASSET_STATUS.UNDER_REPAIR]: 'secondary',
    [ASSET_STATUS.REPAIRED]: 'success',
    [ASSET_STATUS.LOST]: 'error',
    [ASSET_STATUS.SCRAPPED]: 'default',
    [ASSET_STATUS.ARCHIVED]: 'default',

};